import LoadingButton from "@mui/lab/LoadingButton";
import { Box, Button, Card, CardActions, CardContent, CardHeader, CircularProgress, Typography, useTheme } from "@mui/material";
import { ReactNode } from "react";
import PerfectScrollbar from 'react-perfect-scrollbar'
import "react-perfect-scrollbar/dist/css/styles.css";
import CancelIcon from '@mui/icons-material/Cancel';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import DoneIcon from '@mui/icons-material/Done';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

type Props = {
    title?: string,
    subtitle?: string,
    children: ReactNode,
    onNext?: () => void | undefined | Promise<void>,
    onPrevious?: () => void | undefined | Promise<void>,
    onCancel?: () => void | undefined | Promise<void>,
    onFinish?: () => void | undefined | Promise<void>,
    onSave?: () => void | undefined | Promise<void>,
    onClose?: () => void | undefined | Promise<void>,
    onOkay?: () => void | undefined | Promise<void>,
    onConfirm?: () => void | undefined | Promise<void>,
    isSaving?: boolean,
    finishTitle?: string
};

const WizardStep = ({ title, children, onNext, onPrevious, onCancel, onFinish, finishTitle, subtitle, onSave, onClose,onOkay, onConfirm,isSaving = false }: Props) => {
    const lockOtherButtons = isSaving;

    return (
        <Card sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            {title && <CardHeader
                title={title}
                subheader={subtitle}
            />}
            <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <PerfectScrollbar options={{ wheelPropagation: false }}>
                    {children}
                </PerfectScrollbar>
            </CardContent>
            <CardActions sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', gap: 4 }}>
                {onCancel && <Button variant='contained' onClick={onCancel} disabled={lockOtherButtons} endIcon={<CancelIcon/> }>
                    Cancel
                </Button>}
                {onPrevious && <Button variant='contained' onClick={onPrevious} disabled={lockOtherButtons} endIcon={<NavigateBeforeIcon /> }>
                    Previous
                </Button>}
                {onNext && <Button variant='contained' onClick={onNext} disabled={lockOtherButtons} endIcon={<NavigateNextIcon /> }>
                    Next
                </Button>}
                {onFinish && <Button variant='contained' onClick={onFinish} disabled={lockOtherButtons} endIcon={<DoneIcon /> }>
                    {!finishTitle && 'Finish'}
                    {finishTitle}
                </Button>}
                {onOkay && <Button variant='contained' onClick={onOkay} endIcon={<CheckIcon />} disabled={lockOtherButtons }>
                    Okay
                </Button>}
                {onConfirm && <Button variant='contained' onClick={onConfirm} endIcon={<CheckIcon />} disabled={lockOtherButtons}>
                    Confirm
                </Button>}
                {onSave && <Button variant='contained' onClick={onSave} disabled={lockOtherButtons} endIcon={<SaveIcon />}>
                    {isSaving && <>Saving <CircularProgress size={24} sx={{ ml: 5 }} /></>}
                    {!isSaving && 'Save' }
                </Button>}
                {onClose && <Button variant='contained' onClick={onClose} disabled={lockOtherButtons} endIcon={<CloseIcon /> }>
                    Close
                </Button>}
            </CardActions>
        </Card>

    )
}

export default WizardStep